import { AudioManager } from './../../../../AudioManager';
import { GameVars } from "../../../../GameVars";

export class PositionLayer extends Phaser.GameObjects.Container {

    private static POSITION = [
        {x: 100, y: -100},
        {x: 100, y: -100},
        {x: 100, y: 100},
        {x: -100, y: -100}
    ];

    private positionImage: Phaser.GameObjects.Image;
    private index: number;

    constructor(scene: Phaser.Scene, index: number) {

        super(scene);

        this.index = index;

        this.positionImage = new Phaser.GameObjects.Image(this.scene, PositionLayer.POSITION[index].x, PositionLayer.POSITION[index].y, "texture_atlas_language", "position_1");
        this.add(this.positionImage);

        this.visible = false;
    }

    public show(): void {

        this.visible = true;
        this.setScale(.5);
        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250
        });

        this.scene.tweens.add({
            targets: this,
            scaleX: GameVars.players[this.index].position === 1 ? 1.25 : 1,
            scaleY: GameVars.players[this.index].position === 1 ? 1.25 : 1,
            ease: Phaser.Math.Easing.Back.Out,
            duration: 250
        });

        if (GameVars.players[this.index].position < GameVars.numPlayers) {
            this.positionImage.setFrame("position_" + GameVars.players[this.index].position);
            AudioManager.playSound("position_" + GameVars.players[this.index].position);
        } else {
            this.positionImage.setFrame("position_last");
            AudioManager.playSound("position_last");
        }
    }

    public hide(): void {

        this.visible = false;
    }
}
